import React from "react";
import { useState, useEffect } from "react";

export default function Pagination({totalItems, itemsPerPage, currentPage, setCurrentPage}) {
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);

  useEffect(() => {
    setFrom(totalItems === 0 ? totalItems : (currentPage - 1) * itemsPerPage + 1);
    setTo(currentPage * itemsPerPage > totalItems ? totalItems : currentPage * itemsPerPage);
  }, [currentPage, itemsPerPage, totalItems]);

  return (
    <nav
      aria-label="Pagination"
      className="flex items-center justify-between border-0  bg-white py-3 mt-4"
    >
      <div className="hidden sm:block">
        <p className="text-sm text-gray-700">
          Showing <span className="font-medium">{from}</span> to{" "}
          <span className="font-medium">{to}</span> of{" "}
          <span className="font-medium">{totalItems}</span> results
        </p>
      </div>
      <div className="flex flex-1 justify-between sm:justify-end">
        <button className={`relative inline-flex items-center rounded-md ${ currentPage !== 1 ? 'bg-white hover:bg-gray-50 text-gray-800' : 'bg-gray-300 text-gray-500' } px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 focus-visible:outline-offset-0`}
          onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
          Previous
        </button>
        <button className={`relative ml-3 inline-flex items-center rounded-md ${ to !== totalItems ? 'bg-white hover:bg-gray-50 text-gray-800' : 'bg-gray-300 text-gray-500' } px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 focus-visible:outline-offset-0`}
          onClick={() => setCurrentPage(currentPage + 1)} disabled={to === totalItems}>
          Next
        </button>
      </div>
    </nav>
  );
}
